module.exports = __webpack_public_path__ + "img/1-2.88eabe0d.svg";